import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG} from '../common/redux/constantes';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import  CompletionDialog  from './CompletionDialog';
import{  ROLE_VIEWER,STATUS_PROJECT_PUBLISHED } from '../common/redux/constantes'; 
import DownloadCsv from "../common/DownloadCsv"

class Periods extends Component {
  static propTypes = {

  };


  state ={
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
  }
  
  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }

  setDownloadInfo=(info)=>
  {
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:[
             {label:"Reporting Period", key:"reporting_number"},
             {label:"Start Date", key:"start_date"},
             {label:"End Date", key:"end_date"},
             {label:"Planned Value", key:"planned_value"},
             {label:"Cummaltive PV", key:"cumulative"},
             {label:"Earned Value", key:"earned_value"},
             {label:"Cummalative EV", key:"cumulative_earned"},
             {label:"Actual Cost", key:"actual_cost"},
             {label:"Cummulative AC", key:"cumulative_actual"},
             {label:"WP", key:"total_w"},
             {label:"Completion Date", key:"completion_date"},
             ],
             tableName:"ReportingPeriods", 
             type:6
           }
     this.setState({
       tableData:value
     })
   }

  handleClickOpen = (rp) => {
    let action = 1; // 1 Crear 2 Editar
    //Si el workpackage ya esta completado solo modifica la fecha
    if(rp.rp_status === 2)
    {
      action = 2;
    }
    this.setState({ openCompletionDialog: true,action:action,rp_selected:rp.reporting_number});
  };

  handleClose = () => {
    this.setState({ openCompletionDialog: false });
    this.refreshTable();
  };

  render() {
    let actionButtons = [
      rowData => ({
        icon: rowData.rp_status===3?'':'swap_horiz',
        tooltip: rowData.rp_status===3?'':'Update Reporting Period',
        onClick: (event, rowData) => this.handleClickOpen(rowData),
        disabled: rowData.rp_status===3
      }),
      {
          icon: 'refresh',
          tooltip: 'Refresh Data',
          isFreeAction: true,
          onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
      },
      {
          icon: 'save',
          tooltip: 'Save Data',
          isFreeAction: true,
          onClick: () => 
          {
            this.childref.downloadData()
          }
      }
    ];

    if(Number(localStorage.getItem("role"))===ROLE_VIEWER || this.props.project_status !==STATUS_PROJECT_PUBLISHED)
    {
      actionButtons.splice(0,1);
    }


    return (
      <div className="summary-generic-cost">
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:14,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Closing Reporting Periods"
          columns={[
            { 
              title: 'Reporting Period', 
              field: 'reporting_number',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Start Date', 
              field: 'start_date',
              type:'date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'End Date', 
              field: 'end_date',
              type:'date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Planned Value', 
              field: 'planned_value',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Cumulative PV', 
              field: 'cumulative',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Earned Value', 
              field: 'earned_value',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Cumulative EV', 
              field: 'cumulative_earned',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Actual Cost', 
              field: 'actual_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Cumulative AC', 
              field: 'cumulative_actual',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'WP', 
              field: 'total_w',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            // { 
            //   title: 'WP Completed', 
            //   field: 'completed_w',
            //   cellStyle: {
            //     borderRight: "1px solid #d4d4d4"
            //   }
            // },
            { 
              title: 'Completion Date', 
              field: 'completion_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/projects/GeneralReport/' + this.props.project;
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                {
                  formatter = new Intl.NumberFormat('gt-GT', {
                    minimumFractionDigits: 2,
                  });
                }

                let cumulative_actual = 0;
                let cumulative = 0;
                let cumulative_earned = 0;

                result.rps = result.rps.map(o => {
                  if(o.start_date && o.end_date)
                  {
                    o.start_date= moment(o.start_date).format('YYYY-MM-DD')
                    o.end_date= moment(o.end_date).format('YYYY-MM-DD')
                  }
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    cumulative += Number(o.planned_value);
                    cumulative_earned += Number(o.earned_value);
                    cumulative_actual += Number(o.actual_cost);
                    o.cumulative = cumulative;
                    o.cumulative_earned = cumulative_earned;
                    o.planned_value = formatter.format(o.planned_value);
                    o.cumulative = formatter.format(o.cumulative);
                    o.earned_value = formatter.format(o.earned_value);
                    o.cumulative_earned = formatter.format(o.cumulative_earned);
                    o.actual_cost = formatter.format(o.actual_cost);
                    o.cumulative_actual = formatter.format(cumulative_actual);
                  }
                  return o;
                });
                this.setDownloadInfo(result.rps)
                resolve({
                  data: result.rps,
                  page: 0,
                  totalCount: result.rps.length,
                });
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }
          actions={actionButtons}
        />
        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
        <CompletionDialog w_table={this.tableRef} reporting_period={this.state.rp_selected} project={this.props.project} open={this.state.openCompletionDialog}  handleClose={this.handleClose} action={this.state.action}/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    periods: state.periods,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)((Periods));



// WEBPACK FOOTER //
// ./src/features/periods/Periods.js